import React from 'react'
import { ReminderListPopUp } from '../components/ReminderPopUp/ReminderListPopUp'

export default function ReminderModal({history, triggeredReminders, setTriggeredReminders, allReminderData, allReminderDataObject, openReminderListModal, setOpenReminderListModal}) {
     
    return ( 
        <ReminderListPopUp history={history} triggeredReminders={triggeredReminders} 
        setTriggeredReminders={setTriggeredReminders} allReminderData={allReminderData} 
        userReminderObj={allReminderDataObject} open={openReminderListModal} 
        onClose={e=>{setOpenReminderListModal({status:false,data:null})}} /> 
  )
}
